import React from 'react'
import "./style.css"

const Header3 = () => {
  return (
    <div className='home-header'>
        <h2>
            Adieu KGP
        </h2>
        <h1>
            <span>
                </span> Blogs <span>
            </span>
        </h1>
        <p>
            Blogs to preserve memories and experiences of graduating seniors
        </p>
    </div>
  )
}

export default Header3
